import apiMiddleware from "../../../api/apiMiddleware";

// list event categories with pagination and search
const list = async ({ page = 1, search = "" }) => {
  const response = await apiMiddleware.get(
    `event-category-masters?page=${page}${search ? `&search=${search}` : ""}`
  );
  return response.data;
};

// create event category
const create = async (eventCategoryData) => {
  const response = await apiMiddleware.post("event-category-masters", eventCategoryData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

// get event category by id
const getById = async (id) => {
  const response = await apiMiddleware.get(`event-category-masters/${id}`);
  return response.data;
};

// update event category
const update = async ({ id, eventCategoryData }) => {
  const response = await apiMiddleware.post(`event-category-masters/${id}?_method=put`, eventCategoryData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

// delete event category
const deleteEventCategory = async (id) => {
  const response = await apiMiddleware.delete(`event-category-masters/${id}`);
  return response.data;
};

export { list, create, getById, update, deleteEventCategory }; 